import styled from 'styled-components';

export const StyledHealthcareInstitutionLogoImage = styled.img`
   max-width: 351px;
   max-height: 156px;
`;
StyledHealthcareInstitutionLogoImage.displayName = 'StyledHealthcareInstitutionLogoImage';
